import i18n from "i18next";

export interface FontConfig {
  fontFamily: string;
  direction: "ltr" | "rtl";
}

export const getFontConfig = (): FontConfig => {
  const currentLanguage = i18n.language || "en";

  if (currentLanguage === "ar") {
    return {
      fontFamily: "Somar, sans-serif",
      direction: "rtl",
    };
  }

  // Default to English
  return {
    fontFamily: "DM Sans, sans-serif",
    direction: "ltr",
  };
};

// Function to update document styles based on language
export const updateFontStyles = (): void => {
  const { fontFamily, direction } = getFontConfig();

  // Update CSS variable for font family
  document.documentElement.style.setProperty("--app-font-family", fontFamily);

  // Set direction attribute (RTL/LTR)
  document.documentElement.setAttribute("dir", direction);

  // Apply font family directly to body as a fallback
  document.body.style.fontFamily = fontFamily;

  // Add a class to the body for additional styling hooks
  document.body.classList.remove("font-en", "font-ar");
  document.body.classList.add(direction === "rtl" ? "font-ar" : "font-en");
};

// Listen for language changes
i18n.on("languageChanged", () => {
  updateFontStyles();
});
